import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { MailIcon, ArrowLeftIcon, CheckCircleIcon } from 'lucide-react';
const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [isSubmitted, setIsSubmitted] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!email) {
      setError('El correo electrónico es requerido');
      return;
    }
    if (!/\S+@\S+\.\S+/.test(email)) {
      setError('Ingresa un correo electrónico válido');
      return;
    }
    // Aquí iría la lógica para enviar el correo de recuperación
    console.log('Password reset for:', email);
    setIsSubmitted(true);
  };
  if (isSubmitted) {
    return <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 flex items-center justify-center p-4" data-id="element-1473">
        <div className="w-full max-w-md" data-id="element-1474">
          <div className="bg-white rounded-2xl shadow-xl p-8" data-id="element-1475">
            {/* Success Icon */}
            <div className="flex justify-center mb-6" data-id="element-1476">
              <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center" data-id="element-1477">
                <CheckCircleIcon size={32} className="text-green-600" data-id="element-1478" />
              </div>
            </div>
            {/* Success Message */}
            <div className="text-center mb-8" data-id="element-1479">
              <h2 className="text-2xl font-bold text-gray-800 mb-2" data-id="element-1480">
                Correo enviado
              </h2>
              <p className="text-gray-600" data-id="element-1481">
                Hemos enviado un enlace de recuperación a
              </p>
              <p className="text-blue-600 font-medium mt-1" data-id="element-1482">{email}</p>
            </div>
            {/* Instructions */}
            <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-6" data-id="element-1483">
              <p className="text-sm text-gray-700" data-id="element-1484">
                Por favor revisa tu bandeja de entrada y haz clic en el enlace
                para restablecer tu contraseña. Si no ves el correo, revisa tu
                carpeta de spam.
              </p>
            </div>
            {/* Back to Login */}
            <Link to="/login" className="w-full block text-center bg-blue-600 text-white py-2.5 rounded-lg hover:bg-blue-700 transition-colors font-medium" data-id="element-1485">
              Volver al inicio de sesión
            </Link>
            {/* Resend Email */}
            <div className="mt-4 text-center" data-id="element-1486">
              <button onClick={() => setIsSubmitted(false)} className="text-sm text-blue-600 hover:text-blue-700 font-medium" data-id="element-1487">
                ¿No recibiste el correo? Reenviar
              </button>
            </div>
          </div>
        </div>
      </div>;
  }
  return <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 flex items-center justify-center p-4" data-id="element-1488">
      <div className="w-full max-w-md" data-id="element-1489">
        <div className="bg-white rounded-2xl shadow-xl p-8" data-id="element-1490">
          {/* Back Button */}
          <Link to="/login" className="inline-flex items-center text-sm text-gray-600 hover:text-gray-800 mb-6" data-id="element-1491">
            <ArrowLeftIcon size={16} className="mr-1" data-id="element-1492" />
            Volver al inicio de sesión
          </Link>
          {/* Logo and Title */}
          <div className="text-center mb-8" data-id="element-1493">
            <h1 className="text-3xl font-bold text-blue-600 mb-2" data-id="element-1494">
              FinancePro
            </h1>
            <h2 className="text-xl font-semibold text-gray-800 mb-2" data-id="element-1495">
              ¿Olvidaste tu contraseña?
            </h2>
            <p className="text-gray-600" data-id="element-1496">
              Ingresa tu correo electrónico y te enviaremos un enlace para
              restablecer tu contraseña
            </p>
          </div>
          {/* Form */}
          <form onSubmit={handleSubmit} className="space-y-5" data-id="element-1497">
            {/* Email Field */}
            <div data-id="element-1498">
              <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1499">
                Correo electrónico
              </label>
              <div className="relative" data-id="element-1500">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-1501">
                  <MailIcon size={18} className="text-gray-400" data-id="element-1502" />
                </div>
                <input type="email" value={email} onChange={e => {
                setEmail(e.target.value);
                setError('');
              }} className={`w-full pl-10 pr-4 py-2.5 border ${error ? 'border-red-500' : 'border-gray-300'} rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-all`} placeholder="tu@email.com" data-id="element-1503" />
              </div>
              {error && <p className="text-red-500 text-xs mt-1" data-id="element-1504">{error}</p>}
            </div>
            {/* Submit Button */}
            <button type="submit" className="w-full bg-blue-600 text-white py-2.5 rounded-lg hover:bg-blue-700 transition-colors font-medium" data-id="element-1505">
              Enviar enlace de recuperación
            </button>
          </form>
          {/* Additional Help */}
          <div className="mt-6 text-center" data-id="element-1506">
            <p className="text-sm text-gray-600" data-id="element-1507">
              ¿Necesitas ayuda?{' '}
              <a href="#" className="text-blue-600 hover:text-blue-700 font-medium" data-id="element-1508">
                Contáctanos
              </a>
            </p>
          </div>
        </div>
        {/* Footer */}
        <div className="text-center mt-6" data-id="element-1509">
          <p className="text-sm text-gray-600" data-id="element-1510">
            © 2024 FinancePro. Todos los derechos reservados.
          </p>
        </div>
      </div>
    </div>;
};
export default ForgotPassword;